import { GroupTabId } from '../types/types'

// Tab navigation - matching GroupContainer structure
export const ALL_GROUPS_TABS: Record<
  GroupTabId,
  {
    id: GroupTabId
    route: string
    isAdminOnly?: boolean
    url?: string
  }
> = {
  home: {
    id: GroupTabId.HOME,
    route: 'communities-groups-home',
    url: '/home',
  },
  learning: {
    id: GroupTabId.LEARNING,
    route: 'communities-groups-learning',
    url: '/learning',
  },
  events: {
    id: GroupTabId.EVENTS,
    route: 'communities-groups-events',
    url: '/events',
  },
  leaderboard: {
    id: GroupTabId.LEADERBOARD,
    route: 'communities-groups-leaderboard',
    url: '/leaderboard',
  },
  members: {
    id: GroupTabId.MEMBERS,
    route: 'communities-groups-members',
    url: '/members',
  },
  about: {
    id: GroupTabId.ABOUT,
    route: 'communities-groups-about',
    url: '/about',
  },
  settings: {
    id: GroupTabId.SETTINGS,
    route: 'communities-groups-settings-details',
    isAdminOnly: true,
    url: '/settings',
  },
} as const

// Tabs that are always visible regardless of configuration
export const MANDATORY_GROUP_TAB_IDS = [GroupTabId.HOME, GroupTabId.ABOUT] as const

// Tabs that can be toggled on/off by admins
export const OPTIONAL_GROUP_TAB_IDS = [GroupTabId.LEARNING, GroupTabId.EVENTS, GroupTabId.LEADERBOARD, GroupTabId.MEMBERS] as const

// Content tabs persisted in group settings. Admin-only navigation tabs like "settings" are intentionally excluded.
export const CONTENT_GROUP_TABS = [
  { id: GroupTabId.HOME, name: 'DISCUSSION' },
  { id: GroupTabId.LEARNING, name: 'LEARNING' },
  { id: GroupTabId.EVENTS, name: 'EVENTS' },
  { id: GroupTabId.LEADERBOARD, name: 'LEADERBOARD' },
  { id: GroupTabId.MEMBERS, name: 'MEMBERS' },
  { id: GroupTabId.ABOUT, name: 'ABOUT' },
] as const

export type GroupTabName = (typeof CONTENT_GROUP_TABS)[number]['name']

/** Backend tab order for tabsConfiguration array (matches API) */
export const GROUP_TAB_NAMES: GroupTabName[] = CONTENT_GROUP_TABS.map(({ name }) => name)
